<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="container" v-if="!loading">
      <div class="section">
        <div class="columns is-vcentered">
          <div class="column is-2 is-offset-2">
            <img :src="`${event.imgUrl}`" style="width: 150px" />
          </div>
          <div class="column is-6">
            <h1 class="title">{{ event.eventname }}</h1>
          </div>
        </div>
      </div>
      <div class="columns is-vcentered">
        <div class="column is-8 is-offset-2">
          <div class="flex-card light-bordered light-raised">
            <div class="card-body">
              <div class="has-text-centered has-margin-bottom-30">
                <h2 class="title">Manage Your Team</h2>
              </div>
              <div class="columns">
                <div class="column">
                  <p><strong>Team Name: </strong> {{ entry.teamname }}</p>
                </div>
                <div class="column">
                  <p><strong>Category: </strong> {{ entry.category }}</p>
                </div>
              </div>

              <ul class="has-margin-bottom-30">
                <li v-if="event.config && event.config.teamsize">
                  Maximum {{ event.config.teamsize }} per team (2 male and 2
                  female)
                </li>
                <li v-if="disableChange" class="is-danger">
                  <strong
                    >IMPORTANT: You're not allowed to make any more
                    changes.</strong
                  >
                </li>
              </ul>

              <b-table
                :data="filteredMembers"
                :bordered="false"
                :striped="true"
                :narrowed="true"
                :hoverable="true"
                :loading="loading"
                :mobile-cards="true"
                class="has-margin-bottom-30"
              >
                <template slot-scope="props">
                  <b-table-column field="name" label="Name">
                    <div v-if="props.row.dependant">
                      {{ props.row.dependant.firstname }}
                      {{ props.row.dependant.surname }}
                    </div>
                    <div v-else>
                      {{ props.row.user.firstname }}
                      {{ props.row.user.surname }}
                    </div>
                  </b-table-column>

                  <b-table-column label="Gender" centered>
                    <div v-if="props.row.dependant">
                      {{ props.row.dependant.gender }}
                    </div>
                    <div v-else>
                      {{ props.row.user.gender }}
                    </div>
                  </b-table-column>

                  <b-table-column label="">
                    <b-button type="is-danger" @click="removeMember(props.row)"
                      >Remove</b-button
                    >
                  </b-table-column>
                </template>

                <template slot="empty">
                  <section class="section">
                    <div class="content has-text-grey has-text-centered">
                      <p>
                        <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
                      </p>
                      <p>
                        No team members yet.<br />
                        <a href="" @click.prevent="addMember"
                          >Add team member</a
                        >
                      </p>
                    </div>
                  </section>
                </template>
              </b-table>

              <ul>
                <li v-if="members.length === 0 && !disableChange">
                  It is only yourself in the team.
                  <!-- <a href="" ng-click="addMember()">Add</a> some more members. -->
                </li>
                <li v-if="members.length > 0">
                  {{ members.length }} team members in your team including
                  yourself. <br /><strong
                    >Add your team members ONLY, do not add yourself as you're
                    already part of the team</strong
                  >
                </li>
              </ul>
              <div class="has-text-centered has-margin-top-30" v-if="!teamFull">
                <button class="button is-primary" @click="addMember">
                  Add Team Member
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ConfirmModal
      ref="deleteModal"
      title="Confirm?"
      message="Are you sure you want to remove the team member?"
    />
    <b-modal
      :active.sync="showAddMemberModal"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <ValidationObserver v-slot="{ passes }">
        <form @submit.prevent="passes(submit)">
          <div class="modal-card" style="width: auto">
            <header class="modal-card-head">
              <p class="modal-card-title">Add Team Member</p>
            </header>
            <section class="modal-card-body">
              <div class="columns is-multiline">
                <div class="column is-12-desktop">
                  <div class="control">
                    <BaseSelect
                      label="Available Members"
                      v-model="member.evententry"
                    >
                      <option
                        v-for="member in availableMembers"
                        :key="member._id"
                        :value="member._id"
                      >
                        {{ member.user.firstname }}
                        {{ member.user.surname }} ({{ member.user.gender }})
                      </option>
                    </BaseSelect>
                  </div>
                </div>
              </div>
            </section>
            <footer class="modal-card-foot">
              <button
                class="button"
                type="button"
                @click="showAddMemberModal = false"
              >
                Cancel
              </button>
              <b-button
                class="is-primary"
                @click="passes(submit)"
                :loading="saving"
                >Add</b-button
              >
            </footer>
          </div>
        </form>
      </ValidationObserver>
    </b-modal>
  </div>
</template>

<script>
import ConfirmModal from "@/components/ConfirmModal";
import BaseInput from "@/components/BaseInput";
import BaseSelect from "@/components/BaseSelect";
import filters from "@/filters";
import EventEntryApi from "@/api/event-entry";
import AffiliateTeamApi from "@/api/affiliate-team";
export default {
  components: {
    ConfirmModal,
    BaseInput,
    BaseSelect,
  },
  mixins: [filters],
  data() {
    return {
      loading: true,
      member: {},
      entry: {},
      affiliateteam: {},
      event: {},
      members: [],
      saving: false,
      disableChange: false,
      showAddMemberModal: false,
      availableMembers: [],
    };
  },
  computed: {
    filteredMembers() {
      if (this.members.length > 0 && this.affiliateteam.captain) {
        return this.members.filter(
          (member) => member.user._id !== this.affiliateteam.captain._id
        );
      }
      return [];
    },
    teamFull() {
      let limits = [];
      let full = false;
      if (this.event.config && this.event.config.teamrules) {
        this.event.config.teamrules.forEach((item) => {
          item.id = this.event._id;
        });
        limits = this.event.config.teamrules;
      }

      var rule = limits.find((item) => item.id === this.event._id);
      if (rule) {
        if (rule.categories) {
          rule = rule.categories.find(
            (item) => item.name === this.entry.category
          );
          if (rule) {
            full = this.checkLimits(rule.max);
          }
        } else {
          full = this.checkLimits(rule.max);
        }
      } else if (this.event.config && this.event.config.teamsize) {
        full = this.checkLimits(this.event.config.teamsize);
      }
      return full;
    },
  },
  async created() {
    this.entry = await EventEntryApi.getEventEntry(this.$route.params.id);
    if (this.entry) {
      this.event = this.entry.event;
      this.affiliateteam = await AffiliateTeamApi.getByEventEntry(
        this.entry._id
      );
      await this.getMembers(this.affiliateteam._id);
    }

    this.loading = false;
  },
  methods: {
    checkLimits(max) {
      return this.members.length >= max;
    },
    async getMembers(teamId) {
      this.members = await EventEntryApi.getAffiliateTeamMembers(teamId);
    },
    async removeMember(member) {
      let selectedMemberId = member._id;
      let confirmed = await this.$refs.deleteModal.show();
      if (confirmed) {
        await this.actionRemoveMember(selectedMemberId);
      }
    },
    async actionRemoveMember(selectedMemberId) {
      await EventEntryApi.updateAffiliateTeam(selectedMemberId, undefined);
      await this.getMembers(this.affiliateteam._id);
      this.$buefy.toast.open({
        message: "Removed team member successfully!",
        position: "is-top",
        type: "is-success",
      });
    },
    async addMember() {
      this.member = {};
      this.availableMembers = await EventEntryApi.getAvailableAffiliateTeamMembers(
        this.event._id,
        this.entry.category
      );
      this.showAddMemberModal = true;
    },
    async submit() {
      this.saving = true;
      try {
        await EventEntryApi.updateAffiliateTeam(
          this.member.evententry,
          this.affiliateteam._id
        );
        await this.getMembers(this.affiliateteam._id);
        this.showAddMemberModal = false;
        this.saving = false;
        this.$buefy.toast.open({
          message: "Team Member added succesfully!",
          position: "is-top",
          type: "is-success",
        });
      } catch (error) {
        this.saving = false;
        this.$buefy.toast.open({
          message: "Error adding team member.",
          position: "is-top",
          type: "is-danger",
        });
      }
    },
  },
};
</script>
